import * as React from 'react';
import cn from 'classnames';

import { DefaultImg } from './DefaultImg';
import { LetterImg } from './LetterImg';

import * as styles from './styles.css';

interface IProps {
  firstLetter?: string | null;
  circle?: boolean;
  url?: string | null;
  width?: number;
  height?: number;
}

export const _PreviewImg: React.FC<IProps> = ({ url, circle, width, height, firstLetter }: IProps) => {
  const circleClass = circle && styles['circle'];

  if (!url) {
    return firstLetter ? (
      <LetterImg className={cn(styles['letter-img'], circleClass)} width={width} height={height} letter={firstLetter} />
    ) : (
      <DefaultImg className={cn(styles['img'], circleClass)} width={width} height={height} />
    );
  }

  return (
    <div
      data-testid="PreviewImg"
      className={cn(styles['img'], circleClass)}
      style={{
        backgroundImage: `url("${url}")`,
        width,
        height,
      }}
    />
  );
};

export const PreviewImg = React.memo(_PreviewImg);
